// ----------------------------------------------------------------------

export default function Tab() {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
          fontWeight: 500,
          textTransform: 'none',
          minHeight: 40,
          padding: '6px 12px',
        },
      },
    },
  };
}
